export default __webpack_public_path__ + "static/media/qr-frame.b85d57aa.svg";